const reportsUrl = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_REPORTS}`;
const accountsURL = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_ACCOUNTS}`;
const deviceActivationbaseUrl = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_DEVICE_ACTIVATION}`;
export const ReportsOpportunityHistory = `${reportsUrl}/opportunities`;
export const ReportsDeviceData = `${reportsUrl}/devices`;
export const ReportsVTUData = `${reportsUrl}/devices/vtus`;
export const ReportsCameraData = `${reportsUrl}/devices/cameras`;
export const ReportsMilestoneDetails = `${reportsUrl}/opportunityanddevicedetails`;
export const getShipmentEvents = `${accountsURL}/shipment/events`;

export const ReportsDeviceEvents = `${deviceActivationbaseUrl}/reporting/device-events`;

export const AUDIT_LOGS = `${reportsUrl}/auditlogs`;
export const Reports360JobsData = `${reportsUrl}/jobs`;
export const Reports360WorkticketsData = `${reportsUrl}/worktickets`;
export const Reports360JobsCsvData = `${reportsUrl}/jobsCsv`;
export const Reports360WorkticketsCsvData = `${reportsUrl}/workticketsCsv`;
export const ReportsGenerateCustomerPdf = `${reportsUrl}/evc-installation-pdf`;
export const ReportsEvcImageUpload = `${reportsUrl}/evc-images`;
export const ReportsGetVehicleImages = `${reportsUrl}/evc-images`;
export const ReportsGetVehicleImagesByBodyType = `${reportsUrl}/evc-images/body-type`;
export const ReportsBodyTypes = `${reportsUrl}/evc-bodytypes`;
export const ReportsEvcImageSubscribe = `${reportsUrl}/evc-images/subscribe`;
export const VinDecodeUrl = process.env.REACT_APP_NHTSA_VIN_DECODE_URL;
export const VinDecodeApiUrl = `${reportsUrl}/vin`;
export const BulkVehicleUploadUrl = `${reportsUrl}/vehicles`;
export const VinUploadsUrl = `${reportsUrl}/vin-uploads`;
export const ReportsAccountByOpportunity = `${reportsUrl}/account/opportunity`;
export const ReportsPdfTemplate = `${reportsUrl}/evc-pdf-template`;
